// import { AlertChunky as AlertChunkySvg } from '@eventbrite/legacy-eds.iconography';
// import { NotificationBar, TYPE_ERROR } from '@eventbrite/legacy-eds.notification';
import React from 'react';

interface SubmissionErrorProps {
    onClose?: () => void;
    hasError: boolean;
    containerClassName: string;
}

export const SubmissionError: React.FC<React.PropsWithChildren<SubmissionErrorProps>> = ({
    hasError,
    onClose,
    children,
    containerClassName,
    ...containerProps
}) => {
    if (!hasError) {
        return null;
    }

    return (
        <div {...containerProps} className={containerClassName}>
            {/* <NotificationBar
                type={TYPE_ERROR}
                iconType={<AlertChunkySvg />}
                onClose={onClose}
                hasCloseButton={true}
            >
                {children}
            </NotificationBar> */}
        </div>
    );
};
